import { render, staticRenderFns } from "./DangerZoneCard.vue?vue&type=template&id=bccf4742&"
import script from "./DangerZoneCard.vue?vue&type=script&lang=js&"
export * from "./DangerZoneCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports